import { useState } from 'react';
import { loginWithCode } from '../lib/api';
import { useStore } from '../lib/store';
import { openTelegramLink } from '../lib/tg';

const BOT_USERNAME: string = import.meta.env.VITE_BOT_USERNAME ?? '';

export function LoginScreen(): JSX.Element {
  const setAuthStatus = useStore((s) => s.setAuthStatus);
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const canSubmit = /^\d{6}$/.test(code) && !busy;

  async function submit(): Promise<void> {
    if (!canSubmit) return;
    setBusy(true);
    setError(null);
    try {
      await loginWithCode(code);
      setAuthStatus('authed');
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Не удалось войти');
      setBusy(false);
    }
  }

  function openBot(): void {
    if (BOT_USERNAME) {
      openTelegramLink(`https://t.me/${BOT_USERNAME}?start=login`);
    }
  }

  return (
    <div className="flex h-screen flex-col items-center justify-center bg-bg px-6 text-text">
      <div className="w-full max-w-sm space-y-6">
        <div className="space-y-2 text-center">
          <img
            src="/icon-192.png"
            alt="GTA5RP Estate"
            width={88}
            height={88}
            className="mx-auto h-22 w-22 rounded-2xl shadow-lg"
            style={{ height: 88, width: 88 }}
          />
          <div className="font-display text-2xl">
            <span className="font-mono">GTA5RP</span>{' '}
            <span className="text-accent">Estate</span>
          </div>
          <p className="text-sm text-text-dim">
            Вход через Telegram-бота. Получи код в боте и введи его здесь.
          </p>
        </div>

        <button
          onClick={openBot}
          className="w-full rounded-md px-4 py-3 text-sm font-semibold uppercase tracking-wider text-bg transition active:scale-[0.99]"
          style={{ background: 'linear-gradient(135deg, var(--accent), var(--accent-2))' }}
        >
          ✈️ Получить код в Telegram
        </button>

        <div className="space-y-2">
          <input
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={6}
            value={code}
            onChange={(e) => {
              setCode(e.target.value.replace(/\D/g, '').slice(0, 6));
              setError(null);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') void submit();
            }}
            placeholder="000000"
            className="w-full rounded-md border border-white/10 bg-bg-elev px-4 py-3 text-center font-mono text-2xl tracking-[0.4em] text-text outline-none focus:border-accent"
            autoFocus
          />
          {error && <div className="text-center text-xs text-neon-red">{error}</div>}
        </div>

        <button
          onClick={() => void submit()}
          disabled={!canSubmit}
          className="w-full rounded-md border border-accent/40 bg-accent/10 px-4 py-3 text-sm font-semibold uppercase tracking-wider text-accent transition enabled:hover:bg-accent/20 disabled:cursor-not-allowed disabled:opacity-40"
        >
          {busy ? 'Входим…' : 'Войти'}
        </button>

        <p className="text-center text-xs text-text-dim">
          Код действует 5 минут. Если он устарел — запроси новый в боте.
        </p>
      </div>
    </div>
  );
}
